"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseNumericValue = parseNumericValue;
const parse_decimal_number_1 = __importDefault(require("parse-decimal-number"));
// Parses numeric values in either the English or French format
function parseNumericValue(value) {
    if (typeof value !== 'number' && typeof value !== 'string')
        return NaN;
    if (typeof value === 'number')
        return value;
    const floatValue = (0, parse_decimal_number_1.default)(value, ',.'); // English format
    if (!isNaN(floatValue))
        return floatValue;
    return (0, parse_decimal_number_1.default)(value, ' ,'); // French format
}
